import ShippingBox from '@square-icons/react/24/Misc/shipping-box';
import { ReactComponent as Store } from 'images/icons/store.svg';
import t from 'typescript/utilities/translate';
import { CondensedInfoDetails } from 'typescript/apps/checkout_v3/components/condensed_info/types';
import { getShippingEstimateString } from 'typescript/utilities/shipping_strings';
import { TOrderSummary } from 'typescript/types/api/solidshop';
import {
  addressNameString,
  addressString,
} from 'typescript/utilities/order_data';
import {
  fullLocationName,
  pickupLocationAddress,
  pickupPersonInfo,
} from 'typescript/utilities/bopis_strings';

const buildEmptyInfo = (): CondensedInfoDetails => ({
  leadingAccessory: null,
  header: '',
  paragraphs: [],
});

const buildShippingInfo = (
  orderSummaryData: TOrderSummary,
): CondensedInfoDetails => ({
  leadingAccessory: <ShippingBox />,
  header: t('checkout.delivery.title.shipToMe'),
  paragraphs: [
    getShippingEstimateString(orderSummaryData?.shipping_estimate),
    addressString(orderSummaryData?.shipping_address),
    addressNameString(
      orderSummaryData?.shipping_address,
      orderSummaryData?.contact_information,
    ),
  ],
});

const buildPickupInfo = (
  orderSummaryData: TOrderSummary,
): CondensedInfoDetails => ({
  leadingAccessory: <Store />,
  header: t('checkout.delivery.pickup.pickUpInStore'),
  paragraphs: [
    fullLocationName(orderSummaryData?.pickup_location_info),
    pickupLocationAddress(orderSummaryData?.pickup_location_info),
    pickupPersonInfo(orderSummaryData?.pickup_person_info),
  ],
});

const useCondensedInfo = ({ orderSummaryData }): CondensedInfoDetails => {
  if (!orderSummaryData) {
    return buildEmptyInfo();
  } else if (orderSummaryData?.bopis_fulfillment_selected) {
    return buildPickupInfo(orderSummaryData);
  } else {
    return buildShippingInfo(orderSummaryData);
  }
};

export default useCondensedInfo;
